<template lang="html">
  <div class="admin-vacancies-scene">
    <v-app v-if="is_show">
        <router-view></router-view>
    </v-app>
  </div>
</template>

<script>
import { STORE_PREFIX } from '../constants.js';

export default {
    name: 'admin-company-settings',

    props: ['companyId'],

    methods: {
        fetch () {
            this.$store.commit(STORE_PREFIX + 'admin/vacancies/updatePagination', {
                pageNumber: null,
                totalPages: null,
                count: null
            })
            this.$store.dispatch(STORE_PREFIX + 'admin/vacancies/fetch', {company_id: this.companyId})
        }
    },

    created() {
        this.fetch();
    },

    computed: {
        is_show() {
            let subdomain = '';
            if (!window.location || !window.location.host) {
                subdomain = '';
            } else if (window.location.hostname === 'my.release-ai.vcv.team') {
                subdomain = 'ai';
            } else {
                subdomain = window.location.hostname ? window.location.hostname.split('.').pop() : '';
            }

            if (subdomain !== 'ai' && subdomain !== 'localhost' && window.location.hostname !== 'feature-363277089-nexxt.vcv.team') {
                return false;
            } else {
                return true;
            }
        }
    }
}
</script>

<style lang="scss">
    
</style>